const welcome = (recipientName) => {
  return `
    <div style="font-family: Montserrat, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: auto; padding: 15px;">
      <img src="/assets/logo2.svg" alt="FoodBank Logo" style="width: 40px; margin-bottom: 20px; margin: auto" />
      <img src="/assets/emailImage.svg" alt="Email Illustration" style="width: 100%; margin: 20px 0px;" />
      <p style="margin: 15px 0px; font-weight: 500; font-size: 24px;">Hi ${recipientName},</p>
      <p style="font-size: 14px;">We’re excited to have you as part of our growing community. At FoodBank, our mission is to make food accessible, convenient, and stress-free—especially when you need it most.</p>

      <div style="display: flex; justify-content: center;">
        <button style="background-color: #008B50; color: white; border: none; padding: 10px 20px; font-size: 14px; cursor: pointer; border-radius: 42px; margin: 30px 0px;">Create free account</button>
      </div>
      
      <p style="font-size: 14px; margin-top: 30px;">With our innovative food loan service, you can get the meals or groceries you need now and pay later—because we believe no one should have to choose between eating well and staying afloat.</p>
      <p style="font-size: 14px; margin-bottom: 15px;">Let’s help you stock your kitchen with ease. Welcome aboard!</p>

      <p style="font-size: 14px; margin-top: 30px;">Thank you for choosing FoodBank!
      </p>
      <p style="font-size: 14px; margin-bottom: 30px;">We’re glad to have you on board and look forward to supporting you with easy, flexible food access whenever you need it. Let’s take the stress out of mealtime — together
      </p>

      <p style="font-size: 14px;">Best Regards,</p>
      <p style="font-size: 14px; color: #008B50; font-weight: 500;">FoodBank Team</p>
      <br />
      <br />
      <hr />
      <div style="display: flex; justify-content: center; align-items: center; gap: 10px; margin: 20px 0px;">
      <a href="#" target="_blank">
        <img src="/assets/igIcon.svg" alt="instagram Logo" style="width: 40px;" />
      </a>
      <a href="#" target="_blank">
        <img src="/assets/fbIcon.svg" alt="FoodBank Logo" style="width: 40px;" />
      </a>
      </div>
      <hr />
      <div style="text-align: center; font-size: 10px;">
        <p style="margin: 15px 0px 20px 0px">© 2025 FoodBank. All rights reserved.</p>
        <p>You are receiving this mail because you registered to join the <span style="font-weight: 700;">FoodBank</span> platform as a user. This also shows that you agree to our Terms of use and Privacy Policies. If you no longer want to receive mails from use, click the unsubscribe link below to unsubscribe.</p>
        <ul style="display: flex; justify-content: center; align-items: center; gap: 10px; margin: 20px 0px; flex-wrap: wrap;">
          <li style="text-decoration: underline;">
            <a href="#" target="_blank">Privacy policy</a>
          </li>
          <span>●</span>
          <li style="text-decoration: underline;">
            <a href="#" target="_blank">Terms of service</a>
          </li>
          <span>●</span>
          <li style="text-decoration: underline;">
            <a href="#" target="_blank">Help center</a>
          </li>
          <span>●</span>
          <li style="text-decoration: underline;">
            <a href="#" target="_blank">Unsubscribe</a>
          </li>
      </div>
    </div>
  `;
};

module.exports = welcome;
